import { Box, Notification } from "@drone-js/core";
import { usePropertySelectionViewModelValue } from "../propertySelectionViewModelAtom";

export const NotificationEmptySelectedProperty = () => {
    const {
        automaticPropertySelectionCms: { error },
    } = usePropertySelectionViewModelValue();

    return (
        <Box mt="16">
            <Notification
                intent="error"
                description={error}
                asset={{
                    id: "fill.symbol.triangle-exclamation",
                }}
            />
        </Box>
    );
};
